<template>
  <div class="content-wrapper">
    <div class="container-lg">
      <div class="row mb-12">
        <div class="col">
          <div class="page-title-nav row">
            <div class="col-2 col-lg-3">
              <router-link :to="'/member/lotto'" class="btn btn-outline-secondary btn-custom btn-back">
                <i
                  class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                  class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                </router-link>
            </div>
            <div class="col-8 col-lg-6">
              <h1 class="page-title">ผลรางวัล</h1>
            </div>
          </div>
          <div class="content-card text-center" v-if="getResultLotto.reward3_d[0] == '' || getResultLotto.reward3_d[0] == 'xxx'"><!--   -->
            <div class="content-card-title" style="display: block !important;">
              <div v-if="dataInfo">
                {{ dataInfo.group_name }}<br>{{ dataInfo.title }}
              </div>
            </div>
            <div class="content-card-body">
              <div class="row border-bottom ">
                <div class="col-12">
                  <div class="row">
                    <h6 class="mb-0">3 ตัวบน</h6>
                  </div>
                  <div class="row">
                    <h3 class="">
                      {{ getResultLotto.reward6.substring(this.getResultLotto.reward6.length - 3,
                        this.getResultLotto.reward6.length) || 'xxx' }}</h3>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-6 border-right">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <h6 class="mb-0">2 ตัวบน</h6>
                      </div>
                      <div class="row">
                        <h3 class="mb-0">
                          {{
                            getResultLotto.reward6.substring(this.getResultLotto.reward6.length - 2,
                              this.getResultLotto.reward6.length) || 'xxx' }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <h6 class="mb-0">2 ตัวล่าง</h6>
                      </div>
                      <div class="row">
                        <h3 class="mb-0">
                          {{ getResultLotto.reward2_d || xx }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
            <div class="content-card text-center" v-else>
            <div class="content-card-title" style="display: block !important;">
              <div v-if="getResultLotto">
                {{ dataInfo.group_name }}<br>{{ dataInfo.title }}
              </div>
            </div>
            <div class="content-card-body">
              <div class="row border-bottom ">
                <div class="col-12">
                  <div class="row">
                    <h6 class="mb-0">รางวัลที่ 1</h6>
                  </div>
                  <div class="row">
                    <h3 class="" v-if="getResultLotto">{{ getResultLotto.reward6 }}</h3>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-4 border-right">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <h6 class="mb-0">3 ตัวหน้า</h6>
                      </div>
                      <div class="row">
                        <h3 class="mb-0">
                          {{ getResultLotto.reward3_f.filter(Boolean).join(',') || 'xxx, xxx' }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4 border-right">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <h6 class="mb-0">3 ตัวหลัง</h6>
                      </div>
                      <div class="row">
                        <h3 class="mb-0" v-if="getResultLotto">
                          {{ getResultLotto.reward3_d.filter(Boolean).join(',') || 'xxx, xxx' }}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div class="row">
                    <div class="col-12">
                      <div class="row">
                        <h6 class="mb-0">2 ตัวล่าง</h6>
                      </div>
                      <div class="row">
                        <h3 class="mb-0">
                          {{ getResultLotto.reward2_d || xx }}</h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="push">
        <app-rule-by-id-modal :advice="dataInfo.advice" />
      </div>
    </div>
  </div>
</template>
<script>
import { getFlagIcons } from '@/utils'
import ruleByIdModal from '@/components/modals/RuleByIdModalHtml'
import { mapGetters, mapActions } from 'vuex'
export default {
  components: {
    'app-rule-by-id-modal': ruleByIdModal
  },
  async created () {
    try {
      await this.setLoading(true)
      this.clearResult()
      await this.getInquiryRoundInfomationByID(this.$route.params.id)
      this.dataInfo = this.getInquiryRoundInfomation
      await this.fetchResultLotto(this.$route.params.id)
      this.id = parseInt(this.$route.params.id)
    } catch (error) {
      this.setLoading(false)
    }
    this.setLoading(false)
  },
  data: () => {
    return {
      id: '',
      dataInfo: {}
    }
  },
  methods: {
    ...mapActions(['setLoading', 'fetchResultLotto', 'getInquiryRoundInfomationByID', 'clearResult']),
    getIconFlag (title) {
      if (title) {
        return getFlagIcons(title)
      } else {
        return ''
      }
    }
  },
  computed: {
    ...mapGetters(['getResultLotto', 'getInquiryRoundInfomation'])
  }
}
</script>
<style>
.border-right {
    border-right-width: 2px !important;
    border-right-color: #e5e6e8  !important;
    border-right-style: solid !important;
}
</style>
